import { Sparkles } from "lucide-react";
import { PreviewWidget } from "@/components/iv/concept/Widgets";
import { mediaUrl } from "@/lib/api";

export const THEME_COLORS = { cyan: "#0891B2", emerald: "#059669", violet: "#7C3AED" };

// Renders a schema-validated site spec as plain text nodes only (no HTML injection paths).
export const PreviewSite = ({ spec, imageUrl, mobile = false }) => {
  const accent = THEME_COLORS[spec.theme] || THEME_COLORS.cyan;
  const img = mediaUrl(imageUrl);
  return (
    <div className="bg-slate-50 text-slate-900" data-testid="preview-site">
      <nav className="flex items-center justify-between gap-3 border-b border-black/5 bg-white px-4 py-3" data-testid="preview-nav">
        <span className="truncate font-extrabold" style={{ color: accent }} data-testid="preview-brand">{spec.brand_name}</span>
        <span className={`gap-4 text-xs text-slate-500 ${mobile ? "hidden" : "hidden sm:flex"}`}>{spec.nav_links.map((l) => <span key={l}>{l}</span>)}</span>
      </nav>
      <header className={`grid gap-6 px-5 py-8 ${mobile ? "" : "md:grid-cols-2 md:items-center"}`}>
        <div className="min-w-0">
          {spec.pivot_badge && (
            <p className="mb-2 inline-flex items-center gap-1 rounded-full bg-amber-100 px-3 py-1 text-[11px] font-bold text-amber-800" data-testid="preview-pivot-badge">
              <Sparkles className="h-3 w-3" aria-hidden="true" /> {spec.pivot_badge}
            </p>
          )}
          <p className="mb-3 inline-flex rounded-full px-3 py-1 text-[11px] font-semibold text-white" style={{ background: accent }} data-testid="preview-tagline">{spec.tagline}</p>
          <h2 className={`break-words font-extrabold leading-tight ${mobile ? "text-2xl" : "text-2xl sm:text-3xl"}`} data-testid="preview-hero-headline">{spec.hero_headline}</h2>
          <p className="mt-3 text-sm text-slate-600" data-testid="preview-hero-subhead">{spec.hero_subhead}</p>
          <button type="button" className="mt-5 rounded-full px-5 py-2.5 text-sm font-bold text-white" style={{ background: accent }} data-testid="preview-primary-cta">{spec.primary_cta}</button>
        </div>
        <div className="min-w-0 space-y-3">
          {img && <img src={img} alt={`3D visual concept for ${spec.brand_name}`} className="aspect-square w-full max-w-xs rounded-2xl object-cover" loading="lazy" data-testid="preview-concept-image" />}
          <PreviewWidget widget={spec.widget} accent={accent} />
        </div>
      </header>
      <section className={`grid gap-3 px-5 pb-8 ${mobile ? "" : "sm:grid-cols-3"}`} data-testid="preview-features">
        {spec.features.map((f, i) => (
          <article key={i} className="rounded-2xl border border-black/5 bg-white p-4 shadow-sm" data-testid={`preview-feature-${i + 1}`}>
            <h3 className="text-sm font-bold" style={{ color: accent }}>{f.title}</h3>
            <p className="mt-1 text-xs text-slate-600">{f.body}</p>
          </article>
        ))}
      </section>
    </div>
  );
};
